<template>
  <v-app class="app">
    <v-main>
      <navigation-drawer v-if="!isNoAuthRoute" />
      <router-view :key="$route.fullPath" />
    </v-main>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'
import NavigationDrawer from '@/components/NavigationDrawer'
import { isNoAuthRoute } from '@/router'

export default {
  name: 'App',
  components: { NavigationDrawer },

  data() {
    return {
      isNoAuthRoute: false
    }
  },

  watch: {
    $route() {
      this.isNoAuthRoute = isNoAuthRoute()
      if (this.$vuetify.breakpoint.mdAndDown) {
        this.$store.commit('drawerSetStatus', false)
      }
    }
  },

  mounted() {
    if ('es' === navigator.language.substr(0, 2)) {
      this.$i18n.locale = 'es'
      this.$moment.locale('es')
    } else {
      this.$i18n.locale = 'en'
      this.$moment.locale('en')
    }

    if (this.$keycloak.authenticated) {
      this.getAgreements('/connect_agreements?pagination=false&archived=false')
    }

    this.isNoAuthRoute = isNoAuthRoute()
  },

  methods: {
    ...mapActions({
      getAgreements: 'connectagreement/list/default'
    })
  }
}
</script>

<style lang="scss">
.container.page {
  max-width: 1185px !important;
  padding-top: 32px;
  padding-bottom: 48px;
  &.narrow {
    max-width: 840px !important;
  }
}

.content-spinner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.border-left {
  border-left: 1px solid #ddd !important;
}

.border-right {
  border-right: 1px solid #ddd !important;
}

.border-bottom {
  border-bottom: 1px solid #ddd !important;
}

.app-calendar {
  .cv-weeks {
    font-size: 0.85em;
  }
  .cv-header-days,
  .cv-weeks,
  .cv-header {
    border: 0;
  }
  .cv-header-days .cv-header-day:nth-child(7),
  .cv-week .cv-day:nth-child(7) {
    border-right: 0;
  }
  .cv-header {
    background-color: #fff;
    .periodLabel {
      font-size: 1.5em;
      padding-left: 0;
    }
    button {
      border: none;
      padding: 0;
      margin-left: 0;
      margin-right: 0;
    }
  }
  .cv-header-day {
    padding-left: 8px;
    padding-top: 6px;
    color: #757575;
    background-color: #fff;
    align-items: start;
    text-align: left;
    justify-content: start;
  }
  .cv-day {
    background-color: #fff;

    .cv-day-number {
      position: absolute;
      left: 2px;
      top: 2px;
      right: auto;
      width: 24px;
      height: 24px;
      line-height: 18px;
      text-align: center;
      font-size: 15px;
    }

    &:not(.has-event):not(.past) {
      cursor: pointer;
      &:hover {
        background-color: #f5f5f5;
      }
    }
    &.past {
      background-color: #fdfdfd;
      .cv-day-number {
        color: #cccccc;
      }
    }
    &.today {
      background-color: #f5f5f5;
      .cv-day-number {
        background: #4285f4;
        color: #fff;
        border-radius: 50%;
      }
    }
  }
  .outsideOfMonth {
    color: #757575;
  }
  .week1 .cv-day {
    border-top: none;
  }

  .cv-event {
    cursor: pointer;
    border-color: transparent;
    border-radius: 0.25em;
    background-color: #e7e7ff;
    text-overflow: ellipsis;
    &.payment-pending {
      opacity: 0.5;
    }
    &.purple {
      background-color: #f0e0ff;
      border-color: #e7d7f7;
    }
    &.orange {
      background-color: #ffe7d0;
      border-color: #f7e0c7;
    }
    &.toBeContinued {
      border-right-style: none;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    &.isHovered.hasUrl {
      text-decoration: underline;
    }
    &.continued {
      border-left-style: none;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    &.no-ending-stop {
      -webkit-mask-image: -webkit-gradient(linear, 80% center, right center, from(#000), to(rgba(0, 0, 0, 0)));
    }
    &.continued::before,
    &.toBeContinued::after {
      content: ' \21e2 ';
      color: rgba(255, 255, 255, 0.5);
    }
    .startTime,
    .endTime {
      font-weight: bold;
      color: rgba(255, 255, 255, 0.5);
    }
  }

  &.period-year {
    .cv-week {
      min-height: 58px;
    }
  }
}

.v-dialog .v-toolbar__content {
  padding: 0 10px;
}

.primary--text .v-list__tile__avatar .v-avatar img {
  border: 2px solid #1976d2;
}

.card-selected {
  position: relative;
  &:after {
    content: '';
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    top: 0;
    left: 0;
  }
  .v-icon.card-selected-icon {
    display: block;
  }
}

.v-icon.card-selected-icon {
  position: absolute;
  z-index: 2;
  right: 10px;
  top: 10px;
  font-size: 48px;
  color: #fff !important;
  display: none;
}

.triangle-border {
  &:before {
    content: '';
    position: absolute;
    top: -12px;
    left: 0;
    width: 100%;
    height: 14px;
    background-image: url('./assets/triangle.png');
    background-repeat: repeat-x;
    filter: drop-shadow(0 -2px 1px rgba(0, 0, 0, 0.1));
  }
  &:after {
    content: '';
    position: absolute;
    bottom: -12px;
    left: 0;
    width: 100%;
    height: 14px;
    background-image: url('./assets/triangle.png');
    background-repeat: repeat-x;
    filter: drop-shadow(0 -4px 2px rgba(0, 0, 0, 0.2));
    transform: scaleY(-1);
    filter: FlipV;
  }
}
.text-capitalize-first::first-letter {
  text-transform: uppercase;
}
</style>
